var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('main-overview',{attrs:{"columns":_vm.columns,"statusKey":"all_shirt"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }